/**
 * Centralized environment variable configuration
 * All environment variables should be imported from this file
 */

/**
 * API Configuration
 */
export const API_URL =
  import.meta.env['VITE_API_URL'] || 'http://localhost:8000/api'

/**
 * Mapbox Configuration
 */
export const MAPBOX_ACCESS_TOKEN =
  import.meta.env['VITE_MAPBOX_ACCESS_TOKEN'] || ''

export const MAPBOX_STYLE_STREET =
  import.meta.env['VITE_MAPBOX_STYLE_STREET'] ||
  'mapbox://styles/mapbox/streets-v12'

export const MAPBOX_STYLE_SATELLITE =
  import.meta.env['VITE_MAPBOX_STYLE_SATELLITE'] ||
  'mapbox://styles/mapbox/satellite-streets-v12'

/**
 * Map Configuration
 */
export const MAP_CENTER_LNG = Number(
  import.meta.env['VITE_MAP_CENTER_LNG'] || '-75.0'
)

export const MAP_CENTER_LAT = Number(
  import.meta.env['VITE_MAP_CENTER_LAT'] || '17.5'
)

export const MAP_DEFAULT_ZOOM = Number(
  import.meta.env['VITE_MAP_DEFAULT_ZOOM'] || '5'
)

/**
 * OpenStreetMap Nominatim Configuration
 */
export const OSM_NOMINATIM_URL =
  import.meta.env['VITE_OSM_NOMINATIM_URL'] ||
  'https://nominatim.openstreetmap.org'

export const OSM_USER_AGENT =
  import.meta.env['VITE_OSM_USER_AGENT'] || 'Geographic-Map-Scoring-App'

/**
 * Email Configuration
 */
export const EMAIL_APP_URL =
  import.meta.env['VITE_EMAIL_APP_URL'] || 'https://mail.google.com'
